import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import LINK from 'constants/link.const';
import fromObjectToQueryString from 'utils/converters/object/fromObjectToQueryString.util';
import { fromPropsToQuery, fromPropsToQueryString } from 'utils/converters/props/path.util';
import navFor from 'utils/links/navFor.util';
import asObject from 'utils/objects/asObject.util';

import ConfirmationModal from 'common/ConfirmationModal';
import PopupModalContainer from 'common/PopupModal';
import CategoriesScreenContainer from 'onboarding/categories/CategoriesScreen';
import HeaderContainer from 'onboarding/common/Header';
import OnboardingFooter from 'onboarding/common/OnboardingFooter';
import { addInitialCategories, deleteCategory, getCategories } from 'onboarding/services/actions';

class CategoriesScreenWrap extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isFooterButtonActive: true,
      errorMessage: '',
      initCategories: false,
    };
  }

  UNSAFE_componentWillMount() {
    if (!this.props.currentSalon) {
      navFor('CategoriesScreenWrap.componentWillMount()', this.props).push({
        pathname: LINK.onboardingType,
        search: fromPropsToQueryString(this.props),
      });
      return;
    }
    if (
      !this.state.initCategories &&
      !this.props.isPosting &&
      this.props.areCategoriesFetched &&
      this.props.categories.length === 0
    ) {
      this.props.addInitialCategories(this.props.currentSalon.id);
      this.setState({ initCategories: true });
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  UNSAFE_componentWillReceiveProps() {
    if (
      !this.state.initCategories &&
      !this.props.isPosting &&
      this.props.areCategoriesFetched &&
      this.props.categories.length === 0
    ) {
      this.props.addInitialCategories(this.props.currentSalon.id);
      this.setState({ initCategories: true });
    }
  }

  onAddCategoryClick = () => {
    navFor('CategoriesScreenWrap.onAddCategoryClick()', this.props).push({
      pathname: LINK.onboardingEditCategory,
      search: fromPropsToQueryString(this.props),
    });
  };

  onEditCategoryClick = (category) => {
    const categoryId = asObject(category).id;
    navFor('CategoriesScreenWrap.onEditCategoryClick()', this.props).push({
      pathname: LINK.onboardingEditCategory,
      state: { category },
      search: fromObjectToQueryString({ ...fromPropsToQuery(this.props), categoryId }),
    });
  };

  onDeleteCategoryClick = (category) => {
    if (category.id && category.services.length === 0 && this.props.categories.length > 1) {
      this.props.deleteCategory(category.id, this.props.currentSalon.id);
    } else if (category.services.length !== 0) {
      this.setState({
        errorMessage: 'You cannot delete a category that has services assigned to it!',
      });
    } else if (this.props.categories.length === 1) {
      this.setState({ errorMessage: 'You cannot delete your last category!' });
    }

    this.setState({ categoryToDelete: undefined });
  };

  onFooterButtonClicked = () => {
    if (this.state.isFooterButtonActive) {
      navFor('CategoriesScreenWrap.onFooterButtonClicked()', this.props).push({
        pathname: LINK.onboardingServices,
        search: fromPropsToQueryString(this.props),
      });
    }
  };

  hideError = () => void this.setState({ errorMessage: '' });

  render() {
    const { categoryToDelete, isFooterButtonActive, errorMessage } = this.state;
    const { isFetching, currentSalon, isPosting } = this.props;

    return (
      <div data-bem="CategoriesScreenWrap" className="content-wrap">
        {errorMessage && (
          <PopupModalContainer
            popupTitle="Error"
            popupMessage={errorMessage}
            buttonText="Okay"
            buttonCallback={this.hideError}
          />
        )}

        {categoryToDelete && (
          <ConfirmationModal
            popupTitle="DELETE"
            popupMessage="Are you sure?"
            leftButtonText="No"
            rightButtonText="Yes"
            leftButtonCallback={() => {
              this.setState({ categoryToDelete: undefined });
            }}
            rightButtonCallback={() => {
              if (categoryToDelete) {
                this.onDeleteCategoryClick(categoryToDelete);
              }
            }}
          />
        )}

        <HeaderContainer
          titleFirstPart="Add Categories For Your Services"
          description="Group your services by category. We’ve added a few to get you started,
          but you can edit these if you like!"
          backBtnCallBack={() => {
            navFor('CategoriesScreenWrap.render()', 'backBtnCallBack()', this.props).push({
              pathname: currentSalon.pricing_type === 'role' ? LINK.onboardingRoles : LINK.onboardingPriceType,
              search: fromPropsToQueryString(this.props),
            });
          }}
        />

        <CategoriesScreenContainer
          isOnboarding
          salon={currentSalon}
          expandedCategoriesIDs={[]}
          editingCategoriesIDs={[]}
          savedCategoriesIDs={[]}
          errorCategoriesData={[]}
          onEditClick={this.onEditCategoryClick}
          onDeleteClick={(category) => void this.setState({ categoryToDelete: category })}
          onAddCategoryClick={this.onAddCategoryClick}
        />

        <OnboardingFooter
          isFooterButtonActive={isFooterButtonActive}
          onButtonClick={this.onFooterButtonClicked}
          isLoading={isFetching || isPosting}
        />

        {(isPosting || isFetching) && <div className="load-blocker" />}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  cognito: state.cognito,
  categories: state.onboarding.services.categories,
  currentSalon: state.currentSalon,
  isFetching: state.onboarding.services.isFetching,
  isPosting: state.onboarding.services.isPosting,
  areCategoriesFetched: state.onboarding.services.areCategoriesFetched,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ getCategories, addInitialCategories, deleteCategory }, dispatch);

// this extra export is needed for tests that provide their own mock for connect()
export {
  CategoriesScreenWrap as CategoriesScreenWrap4Test,
  mapStateToProps as mapStateToProps4Test,
  mapDispatchToProps as mapDispatchToProps4Test,
};

export default connect(mapStateToProps, mapDispatchToProps)(CategoriesScreenWrap);
